import React from "react";
import VABasicInformation from "./components/VABasicInformation";
import VAGeneralInformation from "./components/VAGeneralInformation";
import VAGuardianForm from "./components/VAGuardianForm";
import VAAttorneyInformation from "./components/VAAttorneyInformation";
import VARequestorInformation from "./components/VARequestorInformation";
import VADocumentUploadForm from "./components/VADocumentUploadForm";
import VABillingInformationForm from "./components/VABillingInformationForm";
import TrusteeBasicInformation from "./components/TrusteeBasicInformation";
import TrusteeGeneralInformation from "./components/TrusteeGeneralInformation";
import TrusteeGuardianForm from "./components/TrusteeGuardianForm";
import TrusteeAttorneyInformationForm from "./components/TrusteeAttorneyInformationForm";
import TrusteeRequestorInformationForm from "./components/TrusteeRequestorInformationForm";
import TrusteeDocumentUploadForm from "./components/TrusteeDocumentUploadForm";
import TrusteeBillingInformationForm from "./components/TrusteeBillingInformationForm";
import ProbateBasicInformation from "./components/ProbateBasicInformation";
import ProbateGeneralInformation from "./components/ProbateGeneralInformation";
import ProbateGuardianForm from "./components/ProbateGuardianForm";
import ProbateAttorneyInformation from "./components/ProbateAttorneyInformation";
import ProbateRequestorInformation from "./components/ProbateRequestorInformation";
import ProbateDocumentUpload from "./components/ProbateDocumentUpload";
import ProbateBillingInformation from "./components/ProbateBillingInformation";
import GuardianshipBasicInformation from "./components/GuardianshipBasicInformation";
import GuardianshipGeneralInformation from "./components/GuardianshipGeneralInformation";
import GuardianshipGuardianForm from "./components/GuardianshipGuardianForm";
import GuardianshipAttorneyInformation from "./components/GuardianshipAttorneyInformation";
import GuardianshipRequestorInformation from "./components/GuardianshipRequestorInformation";
import GuardianshipDocumentUpload from "./components/GuardianshipDocumentUpload";
import GuardianshipBillingInformation from "./components/GuardianshipBillingInformation";
import { ObligeeInformationForm } from "./Helpers/ObligeeInformation";
import { BondNumberSelect } from "./Helpers/BondNumberSelect";

const renderVaSections = (page) => {
  const { globalState, updateGlobalState, role, disabled, data, userdetails } = page;
  return (
    <>
      <VABasicInformation
        globalData={globalState}
        data={globalState.basicInformation}
        updateData={(d) => updateGlobalState("basicInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      <VAGeneralInformation
        globalData={globalState}
        data={globalState.generalInformation}
        updateData={(d) => updateGlobalState("generalInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      <VAGuardianForm
        globalData={globalState}
        data={globalState.guardianDetails}
        updateData={(d) => updateGlobalState("guardianDetails", d)}
        role={role}
        isDisabled={disabled}
        pii_access={userdetails?.is_pii_user}
      />
      <VAAttorneyInformation
        globalData={globalState}
        data={globalState.attorneyInformation}
        updateData={(d) => updateGlobalState("attorneyInformation", d)}
        role={role}
        isDisabled={disabled}
        isGuest={data?.is_guest}
      />
      <ObligeeInformationForm
        globalData={globalState}
        data={globalState.obligeeInformation}
        updateData={(d) => updateGlobalState("obligeeInformation", d)}
        role={role}
        isDisabled={disabled}
        bondType="VA"
        suppressDefaultObligee
      />
      <VARequestorInformation
        globalData={globalState}
        data={globalState.requestorInformation}
        updateData={(d) => updateGlobalState("requestorInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      <VADocumentUploadForm
        globalData={globalState}
        data={globalState.documentUpload}
        updateData={(d) => updateGlobalState("documentUpload", d)}
        role={role}
        pii_access={userdetails?.is_pii_user}
        isDisabled={disabled}
      />
      <VABillingInformationForm
        globalData={globalState}
        data={globalState.billingInformation}
        updateData={(d) => updateGlobalState("billingInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      {(role === "super_user" || role === "internal_user") && (
        <BondNumberSelect
          data={globalState.bondNumber}
          updateData={(d) => updateGlobalState("bondNumber", d)}
        />
      )}
    </>
  );
};

const renderTrusteeSections = (page) => {
  const { globalState, updateGlobalState, role, disabled, data, userdetails, uploadToADLS } = page;
  return (
    <>
      <TrusteeBasicInformation
        globalData={globalState}
        data={globalState.basicInformation}
        updateData={(d) => updateGlobalState("basicInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      <TrusteeGeneralInformation
        globalData={globalState}
        data={globalState.generalInformation}
        updateData={(d) => updateGlobalState("generalInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      <TrusteeGuardianForm
        globalData={globalState}
        data={globalState.guardianDetails}
        updateData={(d) => updateGlobalState("guardianDetails", d)}
        role={role}
        isDisabled={disabled}
        pii_access={userdetails?.is_pii_user}
      />
      <TrusteeAttorneyInformationForm
        globalData={globalState}
        data={globalState.attorneyInformation}
        updateData={(d) => updateGlobalState("attorneyInformation", d)}
        role={role}
        isDisabled={disabled}
        isGuest={data?.is_guest}
      />
      <ObligeeInformationForm
        globalData={globalState}
        data={globalState.obligeeInformation}
        updateData={(d) => updateGlobalState("obligeeInformation", d)}
        role={role}
        isDisabled={disabled}
        bondType="Trustee"
        suppressDefaultObligee
      />
      <TrusteeRequestorInformationForm
        globalData={globalState}
        data={globalState.requestorInformation}
        updateData={(d) => updateGlobalState("requestorInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      <TrusteeDocumentUploadForm
        globalData={globalState}
        data={globalState.documentUpload}
        updateData={(d) => updateGlobalState("documentUpload", d)}
        role={role}
        pii_access={userdetails?.is_pii_user}
        isDisabled={disabled}
        uploadToADLS={uploadToADLS}
      />
      <TrusteeBillingInformationForm
        globalData={globalState}
        data={globalState.billingInformation}
        updateData={(d) => updateGlobalState("billingInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      {(role === "super_user" || role === "internal_user") && (
        <BondNumberSelect
          data={globalState.bondNumber}
          updateData={(d) => updateGlobalState("bondNumber", d)}
        />
      )}
    </>
  );
};

const renderProbateSections = (page) => {
  const { globalState, updateGlobalState, role, disabled, userdetails } = page;
  return (
    <>
      <ProbateBasicInformation
        globalData={globalState}
        data={globalState.basicInformation}
        updateData={(d) => updateGlobalState("basicInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      <ProbateGeneralInformation
        globalData={globalState}
        data={globalState.generalInformation}
        updateData={(d) => updateGlobalState("generalInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      <ProbateGuardianForm
        globalData={globalState}
        data={globalState.guardianDetails}
        updateData={(d) => updateGlobalState("guardianDetails", d)}
        role={role}
        isDisabled={disabled}
        pii_access={userdetails?.is_pii_user}
      />
      <ProbateAttorneyInformation
        globalData={globalState}
        data={globalState.attorneyInformation}
        updateData={(d) => updateGlobalState("attorneyInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      <ObligeeInformationForm
        globalData={globalState}
        data={globalState.obligeeInformation}
        updateData={(d) => updateGlobalState("obligeeInformation", d)}
        role={role}
        isDisabled={disabled}
        bondType="Probate"
        suppressDefaultObligee
      />
      <ProbateRequestorInformation
        globalData={globalState}
        data={globalState.requestorInformation}
        updateData={(d) => updateGlobalState("requestorInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      <ProbateDocumentUpload
        globalData={globalState}
        data={globalState.documentUpload}
        updateData={(d) => updateGlobalState("documentUpload", d)}
        role={role}
        pii_access={userdetails?.is_pii_user}
        isDisabled={disabled}
      />
      <ProbateBillingInformation
        globalData={globalState}
        data={globalState.billingInformation}
        updateData={(d) => updateGlobalState("billingInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      {(role === "super_user" || role === "internal_user") && (
        <BondNumberSelect
          data={globalState.bondNumber}
          updateData={(d) => updateGlobalState("bondNumber", d)}
        />
      )}
    </>
  );
};

const renderGuardianshipSections = (page) => {
  const { globalState, updateGlobalState, role, disabled, userdetails } = page;
  return (
    <>
      <GuardianshipBasicInformation
        globalData={globalState}
        data={globalState.basicInformation}
        updateData={(d) => updateGlobalState("basicInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      <GuardianshipGeneralInformation
        globalData={globalState}
        data={globalState.generalInformation}
        updateData={(d) => updateGlobalState("generalInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      <GuardianshipGuardianForm
        globalData={globalState}
        data={globalState.guardianDetails}
        updateData={(d) => updateGlobalState("guardianDetails", d)}
        role={role}
        isDisabled={disabled}
        pii_access={userdetails?.is_pii_user}
      />
      <GuardianshipAttorneyInformation
        globalData={globalState}
        data={globalState.attorneyInformation}
        updateData={(d) => updateGlobalState("attorneyInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      <ObligeeInformationForm
        globalData={globalState}
        data={globalState.obligeeInformation}
        updateData={(d) => updateGlobalState("obligeeInformation", d)}
        role={role}
        isDisabled={disabled}
        bondType="Guardianship"
        suppressDefaultObligee
      />
      <GuardianshipRequestorInformation
        globalData={globalState}
        data={globalState.requestorInformation}
        updateData={(d) => updateGlobalState("requestorInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      <GuardianshipDocumentUpload
        globalData={globalState}
        data={globalState.documentUpload}
        updateData={(d) => updateGlobalState("documentUpload", d)}
        role={role}
        pii_access={userdetails?.is_pii_user}
        isDisabled={disabled}
      />
      <GuardianshipBillingInformation
        globalData={globalState}
        data={globalState.billingInformation}
        updateData={(d) => updateGlobalState("billingInformation", d)}
        role={role}
        isDisabled={disabled}
      />
      {(role === "super_user" || role === "internal_user") && (
        <BondNumberSelect
          data={globalState.bondNumber}
          updateData={(d) => updateGlobalState("bondNumber", d)}
        />
      )}
    </>
  );
};

export const BOND_RETRIEVE_PAGE_SECTIONS = {
  va: { title: "VA Bond Request", renderSections: renderVaSections },
  trustee: { title: "Trustee Bond Request", renderSections: renderTrusteeSections },
  probate: { title: "Probate Bond Request", renderSections: renderProbateSections },
  guardianship: {
    title: "Guardianship Bond Request",
    renderSections: renderGuardianshipSections,
  },
};
